<style lang="scss">
.admin-aside{
  position:absolute;
  top:80px;
  left:0;
  background:#f7f8f8;
  height:100%;
  width:250px;
  padding-top:60px;
  .list-item{
    a{
      text-align:left;
      padding-left:40px;
      height:58px;
      line-height:58px;
      color:#000;
      display:block;
    }
    .router-link-exact-active{
      background:#00698d;
      color:#fff;
      font-weight: bold;
    }
  }
}
</style>
<template>
  <aside class="admin-aside">
    <ul class="admin-menu-list">
      <li class="list-item"><router-link to="/AdminUser">관리자 관리</router-link></li>
      <li class="list-item"><router-link to="/AdminEstate">매물 관리</router-link></li>
      <li class="list-item"><router-link to="/RecommendedItems">추천 매물 관리</router-link></li>
      <li class="list-item"><router-link to="/ExpertManagement">전문가 관리</router-link></li>
      <li class="list-item"><router-link to="/AdminNotice">공지사항 / Q&#38;A</router-link></li>
      <li class="list-item"><router-link to="/AdminDocItem">서식상품관리</router-link></li>
      <li class="list-item"><router-link to="/AdminReference">서식자료</router-link></li>
      <li class="list-item"><router-link to="/AdminBanner">배너 관리</router-link></li>
      <li class="list-item"><router-link to="/AdminQna">답변게시판 관리</router-link></li>
    </ul>
  </aside>
</template>
<script>
export default {
  name: 'AdminSide',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminSide.vue